export default __webpack_public_path__ + "question-mark.2457c056e1074b85.svg";